import _ from 'lodash';
import axios from 'axios';
import { getStoreForLocal, isDevelopment } from '../utils';
import { apiUrl, authToken } from '.';

const options = {
  baseURL: apiUrl,
  headers: {
    'content-type': 'application/json',
  },
  credentials: true,
  crossDomain: true,
};
if (!_.isEmpty(authToken)) {
  options.headers.Authorization = `Bearer ${authToken}`;
}

const http = axios.create(options);

http.interceptors.request.use((config) => {
  // add any required config before sending the request

  if (isDevelopment()) {
    const storeId = getStoreForLocal();
    if (!_.isEmpty(storeId)) {
      config.headers['X-SG-Store'] = storeId;
    }
  }

  return config;
});

http.interceptors.response.use(
  (config) =>
    // this is a common place to take action based on the response

    config,
  (error) => {
    const { status, data } = error?.response || {};
    if (
      status === 401 &&
      data.code === 401 &&
      error.request.responseURL.indexOf('logout') === -1 &&
      error.request.responseURL.indexOf('login') === -1
    ) {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  },
);

export default http;
